export default {
  googleMapApiKey: "AIzaSyCWhxgdzJkH6RgdjMiSFgMke2-QZMQQsVs",
  googleMeasurementId: "GTM-NFWXC3MQ"
}
